import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const transformLinkUri = ReactMarkdown.uriTransformer;
// React 18 warns about the library's legacy defaultProps; preserve that default explicitly.
delete ReactMarkdown.defaultProps;

const WecomMarkdownContent = ({ content }) => (
  <div className="wecom-markdown">
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      skipHtml
      transformLinkUri={transformLinkUri}
      components={{
        a: ({ node, children, ...props }) => (
          <a
            {...props}
            target="_blank"
            rel="noopener noreferrer"
          >
            {children}
          </a>
        )
      }}
    >
      {String(content || '')}
    </ReactMarkdown>
  </div>
);

export default WecomMarkdownContent;
